import React, { useEffect } from "react";
import Header from "../../../components/User/Header/Header"
import Footer from "../../../components/User/Footer/Footer"

function InternationalLuggageShipping() {

   useEffect(()=>{
  window.scrollTo(0,0)
    },[])

  return (
    <div className="page-wrapper">
      <Header />
      {/* Hero Section  */}
      <section
        class="call-to-action-one sp-four"
        //   style={{ backgroundImage: `url(${HomeBanner})` }}
      >
        <div class="container">
          <div class="sec-title-one white text-center">
            <h2>Redefining International Luggage Shipping Experience</h2>
          </div>
        </div>
      </section>
      <section className="why-chooseus sp-four">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-md-12 col-sm-12">
              <div className="choose-left-content">
                <div className="sec-title-one">
                  {/* <h5>Our Qualification</h5> */}
                  <h2>
                    <span>Move with peace,</span>
                    <br /> leave stress behind
                  </h2>
                </div>
                <div className="text mt-45">
                  <p>
                    Travelling has never been easy and so is shipping.
                    CarryMyBaggage was introduced with a vision to simplify
                    International shipping of unaccompanied baggage anywhere
                    around the world. Unaccompanied baggage is that extra
                    baggage that exceeds the allowed limit on your ticket and is
                    sent separately. CarryMyBaggage is a great option for
                    students who are studying in other countries, people
                    relocating internationally, group travelers, holidaymakers
                    and whosoever having extra baggage to send anywhere in the
                    world. Sending your baggage through CarryMyBaggage is
                    effortless, safe and reliable.{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-md-12 col-sm-12">
              <div className="choose-right-area">
                <figure>
                  <img
                    src={require("../../../images/resource/shoose-us-1.jpg")}
                    alt=""
                  />
                </figure>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 col-md-12 col-sm-12">
              <div className="choose-left-content">
                <div className="text mt-45">
                  <p>
                    CarryMyBaggage takes immense pride in presenting itself as a
                    first of its kind shipping company dedicated to serve
                    solution to people with unaccompanied baggage, thus becoming
                    the only online digital portal to make the whole process of
                    sending unaccompanied baggage internationally as simple as
                    it could be. From the point of getting a quote to the point
                    of delivery of baggage, CarryMyBaggage enables its customers
                    to stay updated with just a click of a button.
                    CarryMyBaggage takes up all the complexity of sending your
                    baggage safely while restoring its customer’s trust and
                    confidence with online tracking system to track their
                    baggage. International shipping and global movement of
                    baggage is a complex process involving a lot of efforts and
                    complications. At CarryMyBaggage, the dedicated team of
                    professionals knows every pros and cons of shipping baggage
                    internationally, providing full transport management and
                    even door to door pick up of baggage ensuring safe and
                    careful handling of your precious stuff.
                  </p>
                  <p>
                    CarryMyBaggage is providing solution to every of that many
                    reasons you have for sending your baggage overseas. Whether
                    you are a student studying abroad, or a person relocating
                    country or someone sending items to friends and family
                    living in other countries, CarryMyBaggage offers affordable
                    baggage shipping solutions worldwide with over 1000
                    international routes. Sending your baggage ahead of you
                    makes your journey stress free and relaxing. For students in
                    particular, baggage shipping is a great choice as
                    CarryMyBaggage offers super fast transit times and with
                    economical costing.
                  </p>
                  <p>
                    When you book with CarryMyBaggage for your international
                    baggage shipping, CarryMyBaggage makes sure that you get the
                    best of rates, convenient door to door pickup and delivery
                    services, fast transit times, complete online tracking and
                    dedicated customer support via call or email.
                  </p>
                  <p>
                    CarryMyBaggage completely understand that it’s very natural
                    to feel concerned and worried about the safety of your
                    baggage, so to give you the satisfaction and peace of mind
                    our team endeavor to provide a seamless international
                    baggage shipping service.
                  </p>
                  <p>
                    Choosing CarryMyBaggage for your international baggage
                    shipping can save you time, money and energy. CarryMyBaggage
                    International baggage shipping service is much more
                    convenient, reliable and affordable.   For an end to end solution for your international baggage
                    shipping–choose Carrymybaggage.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default InternationalLuggageShipping;
